import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

const Wrapper = styled.footer`
  background: #b4e4f9;
`

const List = styled.ul`
  width: 100%;
  padding: 1.5em 20px 1.5em;
  max-width: ${props => props.theme.sizes.maxWidth};
  margin: 0 auto;
  text-align: center;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: flex-start;
  }
`

const Item = styled.li`
  display: inline-block;
  padding: 0.25em 0;
  width: 100%;
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    width: auto;
  }
  a {
    font-weight: 600;
    transition: all 0.2s;
    line-height: 48px;
    font-size: 0.9em;
    text-decoration: none;
    margin-left: 15px;
    color: ${props => props.theme.colors.base};
    &:hover {
      color: ${props => props.theme.colors.highlight};
    }
  }
  .copyright {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      background: #fff;
    }
    a {
      margin-left: 5px;
      text-decoration: none;
    }
  }
`

const Footer = () => (
  <Wrapper>
    <List>
      <Item>
        <div className="copyright">
          <img src="/images/mag-min.png" width="40" height="40" />
          <a
            rel="nofollow"
            target="_blank"
            rel="noopener noreferrer"
            href="https://twitter.com/inukai_tsuna"
            className="webfont"
          >
            {' '}
            @inukai_tsuna
          </a>
        </div>
      </Item>
      <Item>
        <Link to="/term/">利用規約</Link>
        <Link to="/contact/">お問い合わせ</Link>
      </Item>
    </List>
  </Wrapper>
)

export default Footer
